module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/422b48c2206d5240a6717c92496ba21a.svg";